(() => {
  const drawer = document.querySelector("[data-drawer]");
  const openButtons = document.querySelectorAll("[data-drawer-open]");
  const closeButtons = document.querySelectorAll("[data-drawer-close]");

  if (!drawer) return;

  const open = () => {
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  };

  const close = () => {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  };

  openButtons.forEach((button) => button.addEventListener("click", open));
  closeButtons.forEach((button) => button.addEventListener("click", close));
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") close();
  });
})();

(() => {
  const hero = document.querySelector("[data-hero-rotator]");
  if (!hero) return;

  const slides = [...hero.querySelectorAll("[data-hero-slide]")];
  if (slides.length < 2) return;

  let activeIndex = 0;
  let timer;
  let touchStartX = 0;
  let touchStartY = 0;

  const activate = (index) => {
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle("is-active", slideIndex === activeIndex);
    });
  };

  const restart = () => {
    stop();
    start();
  };

  const next = () => {
    activate(activeIndex + 1);
    restart();
  };

  const previous = () => {
    activate(activeIndex - 1);
    restart();
  };

  const start = () => {
    timer = window.setInterval(() => activate(activeIndex + 1), 10000);
  };

  const stop = () => {
    window.clearInterval(timer);
  };

  hero.addEventListener("mouseenter", stop);
  hero.addEventListener("mouseleave", start);
  hero.addEventListener("focusin", stop);
  hero.addEventListener("focusout", start);
  hero.addEventListener("click", (event) => {
    if (event.target.closest("a, button")) return;
    next();
  });
  hero.addEventListener(
    "touchstart",
    (event) => {
      const touch = event.changedTouches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    },
    { passive: true }
  );
  hero.addEventListener(
    "touchend",
    (event) => {
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;

      if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY)) return;
      if (deltaX < 0) next();
      else previous();
    },
    { passive: true }
  );

  activate(0);
  start();
})();

(() => {
  const drawer = document.querySelector("[data-filter-drawer]");
  const openButton = document.querySelector("[data-filter-open]");
  const closeButtons = document.querySelectorAll("[data-filter-close]");

  if (!drawer || !openButton) return;

  const open = () => {
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  };

  const close = () => {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  };

  openButton.addEventListener("click", open);
  closeButtons.forEach((button) => button.addEventListener("click", close));
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") close();
  });
})();

(() => {
  const fallback = document.querySelector("[data-filter-fallback]");
  if (!fallback) return;

  const collectionUrl = fallback.dataset.collectionUrl || "/collections/all";
  const handleize = (value) =>
    value
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  fallback.querySelectorAll(".filter-group[open]").forEach((group) => {
    group.removeAttribute("open");
  });

  fallback.querySelectorAll(".filter-link-list").forEach((list) => {
    const choiceList = document.createElement("div");
    choiceList.className = "filter-choice-list";

    list.querySelectorAll(".filter-link").forEach((link) => {
      const text = link.textContent.trim();
      const isPrice = link.href.includes("filter.v.price");
      const label = document.createElement("label");
      label.className = `filter-choice${link.classList.contains("is-active") ? " is-active" : ""}`;
      const input = document.createElement("input");
      input.type = isPrice ? "radio" : "checkbox";
      if (isPrice) {
        input.name = "fallback_price";
        input.dataset.filterPrice = "";
        input.value = link.href.split("?")[1] || "";
      } else {
        input.dataset.filterTag = "";
        input.value = handleize(text);
      }
      input.checked = link.classList.contains("is-active");
      const span = document.createElement("span");
      span.textContent = text;
      label.append(input, span);
      choiceList.append(label);
    });

    list.replaceWith(choiceList);
  });

  if (!fallback.querySelector("[data-filter-apply]")) {
    const actions = document.createElement("div");
    actions.className = "filter-form__actions";
    actions.innerHTML = `
      <button class="button button--primary" type="button" data-filter-apply>Apply filters</button>
      <a class="button button--ghost" href="${collectionUrl}">Clear all</a>
    `;
    fallback.querySelector(".filter-note")?.before(actions);
  }

  const applyButton = fallback.querySelector("[data-filter-apply]");
  const tagInputs = fallback.querySelectorAll("[data-filter-tag]");
  const priceInputs = fallback.querySelectorAll("[data-filter-price]");

  fallback.querySelectorAll(".filter-choice-list").forEach((list) => {
    if (list.querySelector(".filter-choice")) return;
    list.closest(".filter-group")?.remove();
  });

  const refreshChoiceState = () => {
    [...tagInputs, ...priceInputs].forEach((input) => {
      input.closest(".filter-choice")?.classList.toggle("is-active", input.checked);
    });
  };

  const apply = () => {
    const tags = [...tagInputs].filter((input) => input.checked).map((input) => input.value);
    const price = [...priceInputs].find((input) => input.checked);
    const path = tags.length ? `${collectionUrl}/${tags.join("+")}` : collectionUrl;

    window.location.href = price ? `${path}?${price.value}` : path;
  };

  [...tagInputs, ...priceInputs].forEach((input) => {
    input.addEventListener("change", refreshChoiceState);
  });
  applyButton?.addEventListener("click", apply);
  refreshChoiceState();
})();

(() => {
  const initialize = (scope) => {
    const products = scope.matches?.("[data-product-variants]")
      ? [scope]
      : [...scope.querySelectorAll("[data-product-variants]")];

    products.forEach((product) => {
      if (product.dataset.variantSyncBound === "true") return;
      const form = product.querySelector(".product-form");
      const price = product.querySelector("[data-product-price]");
      const state = product.querySelector("[data-variant-state]");
      const input = form?.querySelector('input[name="id"]');
      const button = form?.querySelector("[data-product-submit]");
      const status = form?.querySelector("[data-variant-status]");
      if (!form || !price || !state || !input || !button || !status) return;

      product.dataset.variantSyncBound = "true";
      const choices = [...form.querySelectorAll("[data-product-option]")];
      let sequence = 0;
      let controller;
      let pending = false;

      const unavailable = (error) => {
        input.value = "";
        input.disabled = true;
        button.disabled = true;
        button.textContent = button.dataset.unavailableLabel;
        price.innerHTML = "";
        price.hidden = true;
        status.textContent = error ? status.dataset.errorLabel : "";
        status.hidden = !error;
      };

      const applyVariant = (nextState, markup, values) => {
        const id = nextState.dataset.variantId || "";
        const options = [...nextState.querySelectorAll("[data-variant-option]")]
          .map((option) => option.dataset.variantOption);
        const matches = !choices.length || (options.length === values.length
          && options.every((value, index) => value === values[index]));
        if (!id || !matches) {
          unavailable(false);
          return "";
        }

        const available = nextState.dataset.variantAvailable === "true";
        input.value = id;
        input.disabled = false;
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldOutLabel;
        price.innerHTML = markup;
        price.hidden = false;
        return id;
      };

      if (state.dataset.variantId === input.value) {
        applyVariant(state, price.innerHTML, choices.map((choice) => choice.value));
      } else {
        unavailable(false);
      }

      form.addEventListener("submit", (event) => {
        if (pending || input.disabled || !input.value || button.disabled) event.preventDefault();
      });

      form.addEventListener("change", async (event) => {
        if (!event.target.matches?.("[data-product-option]")) return;
        const values = choices.map((choice) => choice.value);
        const ids = choices.map((choice) => choice.selectedOptions[0]?.dataset.optionValueId);
        const current = ++sequence;
        controller?.abort();
        controller = new AbortController();
        pending = true;
        form.setAttribute("aria-busy", "true");
        unavailable(false);
        button.textContent = button.dataset.updatingLabel;

        try {
          if (ids.some((id) => !id)) throw new Error("Missing option value ID");
          const requestUrl = new URL(window.location.href);
          requestUrl.hash = "";
          requestUrl.searchParams.delete("variant");
          requestUrl.searchParams.delete("sections");
          requestUrl.searchParams.set("section_id", product.dataset.sectionId);
          requestUrl.searchParams.set("option_values", ids.join(","));
          const response = await fetch(requestUrl.toString(), {
            signal: controller.signal,
            credentials: "same-origin",
            headers: { Accept: "text/html" },
          });
          if (!response.ok) throw new Error("Section request failed");
          const markup = await response.text();
          if (current !== sequence || !product.isConnected) return;

          const rendered = new DOMParser().parseFromString(markup, "text/html");
          const nextProduct = [...rendered.querySelectorAll("[data-product-variants]")]
            .find((node) => node.dataset.sectionId === product.dataset.sectionId);
          const nextState = nextProduct?.querySelector("[data-variant-state]");
          const nextPrice = nextProduct?.querySelector("[data-product-price]");
          const nextInput = nextProduct?.querySelector(".product-form")?.querySelector('input[name="id"]');
          if (!nextState || !nextPrice || !nextInput) throw new Error("Invalid product section");
          if ((nextState.dataset.variantId || "") !== nextInput.value) throw new Error("Inconsistent variant ID");

          const id = applyVariant(nextState, nextPrice.innerHTML, values);
          const url = new URL(window.location.href);
          url.searchParams.delete("section_id");
          url.searchParams.delete("sections");
          if (id) {
            url.searchParams.set("variant", id);
            url.searchParams.delete("option_values");
          } else {
            url.searchParams.delete("variant");
            url.searchParams.set("option_values", ids.join(","));
          }
          window.history.replaceState(window.history.state, "", url.toString());
        } catch (error) {
          if (current !== sequence || !product.isConnected) return;
          unavailable(true);
        } finally {
          if (current === sequence) {
            pending = false;
            form.removeAttribute("aria-busy");
          }
        }
      });
    });
  };

  initialize(document);
  document.addEventListener("shopify:section:load", (event) => initialize(event.target));
})();
